import { UserProfileAdd as UserProfileAdd24 } from 'blaze-ui/icons/24'
import { useModals } from 'almanac-ui/Modal'
import { ShareSheetV2 } from 'common/ShareSheetV2/ShareSheetV2'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { ShareSheetDrawer } from 'common/ShareSheetV2/Drawer/ShareSheetDrawer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { UserProfileAdd } from 'blaze-ui/icons'
import { useDesignAccessRequestLocationHandler } from 'hooks/useDesignAccessRequestLocationHandler'

interface Props {
  fileId: string
}

export const ShareButton = observer(({ fileId }: Props) => {
  const { openModal: openShareModal } = useModals()
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()
  useDesignAccessRequestLocationHandler(fileId)

  const openDrawer = () => {
    drawersStore.openDrawer(ShareSheetDrawer, {
      file: {
        id: fileId,
        type: 'design',
      },
    })
  }

  const openModal = () => {
    openShareModal(ShareSheetV2, {
      file: {
        id: fileId,
        type: 'design',
      },
    })
  }

  return isMobile ? (
    <MobileButton icon={UserProfileAdd} onPress={openDrawer} aria-label="Share" />
  ) : (
    <Button icon={UserProfileAdd24} onPress={openModal} aria-label="Share">
      Share for Review
    </Button>
  )
})
